import { createAction } from '@reduxjs/toolkit';

export const addAssist = createAction('[AssistTrip] addAssist');
export const completeLoading = createAction('[AssistTrip] completeLoading');
export const error = createAction('[AssistTrip] error');
export const closeErrorModal = createAction('[AssistTrip] closeErrorModal');
